import { defineChain } from 'viem';
import { getEnabledChains } from './chains/registry';

export const SELECTED_CHAIN_STORAGE_KEY = 'usdn:selected-swap-chain:v2';

export const buildPrivyEvmChain = chain =>
  defineChain({
    id: Number(chain.networkId),
    name: chain.networkLabel || chain.name,
    nativeCurrency: chain.nativeCurrency || {
      name: 'Ether',
      symbol: 'ETH',
      decimals: 18,
    },
    rpcUrls: {
      default: {
        http: [chain.rpcUrl],
      },
      public: {
        http: [chain.rpcUrl],
      },
      privyWalletOverride: {
        http: [chain.rpcUrl],
      },
    },
    blockExplorers: {
      default: {
        name: chain.name,
        url: chain.blockExplorerUrl || chain.explorerBaseUrl?.replace(/\/tx\/?$/, ''),
      },
    },
  });

export const getEnabledEvmChains = () =>
  getEnabledChains().filter(chain => chain.adapter === 'evm');

export const buildPrivyEvmChains = (chains = getEnabledEvmChains()) =>
  chains.map(buildPrivyEvmChain);

export const buildPrivyRpcConfig = (chains = getEnabledEvmChains()) => ({
  rpcUrls: chains.reduce((rpcUrls, chain) => {
    rpcUrls[Number(chain.networkId)] = chain.rpcUrl;
    return rpcUrls;
  }, {}),
});

export const getPrivyDefaultChain = ({
  enabledChains = getEnabledChains(),
  privyChains = buildPrivyEvmChains(enabledChains.filter(chain => chain.adapter === 'evm')),
  storage = typeof window !== 'undefined' ? window.localStorage : undefined,
} = {}) => {
  if (storage) {
    try {
      const storedChainKey = storage.getItem(SELECTED_CHAIN_STORAGE_KEY);
      const storedChain = enabledChains.find(
        chain => chain.key === storedChainKey && chain.adapter === 'evm'
      );
      const storedPrivyChain = privyChains.find(
        chain => chain.id === Number(storedChain?.networkId)
      );
      if (storedPrivyChain) return storedPrivyChain;
    } catch {
      // Ignore storage failures and use the first configured EVM chain.
    }
  }
  return privyChains[0];
};
